<!--  -->
<template>
  <v-row justify="center">
    <v-dialog
      id="term_condition"
      :model-value="termsOfUseModal"
      scrollable
      persistent
      :fullscreen="$vuetify.display.xs"
      max-width="800px"
    >
      <v-card>
        <v-divider class="under-title-devider" />
        <v-row justify="center" class="term-condition-content">
          <v-col cols="12">
            <v-card-text
              class="text-content card-bottom-padding"
              id="scroll-target-policy"
              v-scroll:#scroll-target-policy="onScroll"
            >
              <div v-html="termsOfUseContent"></div>
            </v-card-text>
          </v-col>
        </v-row>
        <transition name="fade">
          <v-row v-if="$vuetify.display.xs" v-show="offsetTop === 0" class="scroll-to-continue">
            <v-col cols="12">{{ $t('L_scroll_to_continue') }}</v-col>
          </v-row>
        </transition>
        <v-card-actions class="text-center justify-center">
          <v-row>
            <v-col cols="12" class="pa-4">
              <OnexButton
                color="primary"
                :aria-label="$t('L_close_terms_of_use')"
                @click="$emit('hidetermsOfUseModal')"
              >
                {{ $t('L_close') }}
              </OnexButton>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'TermsOfUse',
  components: {
    OnexButton,
  },
  data() {
    return {
      offsetTop: 0,
    };
  },
  props: {
    termsOfUseModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    termsOfUseContent: {
      type: String,
      required: true,
      default: '',
    },
  },
  methods: {
    // eslint-disable-next-line
    onScroll(e: any) {
      this.offsetTop = e.target.scrollTop;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.heading {
  font-size: 20px;
}
.sub-heading {
  color: #02579e !important;
}
.term-condition-content {
  overflow-y: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.modal-content {
  padding: 20px 20px 30px 20px;
  .scroll-to-continue {
    text-align: center;
    z-index: 1;
    position: absolute;
    bottom: 130px;
    width: 100%;
    span {
      padding: 6px 20px;
      font-size: 16px;
      font-weight: 600;
      background-color: #d8d8d8;
      border-radius: 2px;
    }
  }
  .v-card__title {
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    color: #333333;
    display: block;
    padding: 0;
  }
  .under-title-devider {
    margin: 10px 16px 10px 16px;
    border-color: #d4d4d4;
  }
  .text-content {
    margin: 0 0 10px 0;
    &.v-card__text {
      &:after {
        height: 10em;
        width: 90%;
        position: absolute;
        bottom: calc(50px + 2.7em);
        background: rgba(240, 248, 255, 0) linear-gradient(to top, #fff, rgba(255, 255, 255, 0))
          repeat scroll 0 0;
        content: '';
      }
    }
  }
}
.v-dialog--fullscreen {
  > .v-card {
    padding-bottom: 20px !important;
  }
  .modal-content {
    .v-card__title {
      background: #063562;
      font-size: 20px;
      color: #ffffff;
      padding: 11px 0 11px 0;
      font-weight: 600;
      position: relative;
      .v-icon {
        position: absolute;
        top: 15px;
        right: 15px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
.card-bottom-padding.v-card__text {
  padding-bottom: 120px;
}
</style>
